"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
function view() {
    var _this = this;
    var getStateByProps = function (props) {
        var state = {
            applyWithButtonLabel: props.applyWithButtonLabel,
            applyWithServices: []
        };
        var applyWithServices = [];
        props.services.forEach(function (service, index) {
            var providerId = service.providerId.toLowerCase();
            switch (providerId) {
                case '3d8e652c-9e82-4f76-9dde-6b90dafd2086':
                case '18e5738f-f8d4-460b-b339-cb9a742acbf3':
                    var serviceData = {};
                    serviceData["tag"] = "apply_with_" + service.name.toLowerCase();
                    serviceData["buttonText"] = state.applyWithButtonLabel.replace('{0}', service.name);
                    switch (service.name.toLowerCase()) {
                        case "linkedin":
                            serviceData["color"] = "LinkedIn";
                            serviceData["iconName"] = "LinkedIn";
                            break;
                        case "seek":
                            serviceData["color"] = "Seek";
                            serviceData["iconName"] = "Seek";
                            break;
                        default:
                            break;
                    }
                    service.extras = serviceData;
                    applyWithServices.push(service);
                    break;
                case '4792074a-eb93-4c52-bc56-0afb057fccc5':
                    state['awliEnabled'] = true;
                    state['awliApiKey'] = service.credentials.apiKey;
                    state['awliIntegrationContext'] = service.credentials.integrationContext;
                    csod.viewModel.applyWithLinkedInData.isEnabled = true;
                    csod.viewModel.applyWithLinkedInData.apiKey = service.credentials.apiKey;
                    csod.viewModel.applyWithLinkedInData.integrationContext = service.credentials.integrationContext;
                    break;
            }
        });
        state.applyWithServices = applyWithServices;
        return state;
    };
    return {
        state: getStateByProps(this.props),
        initialize: function () { return Promise.resolve(); },
        receivedProps: function (nextProps) {
            var applyWithServices = getStateByProps(nextProps).applyWithServices;
            _this.view.state.applyWithServices = applyWithServices;
            return Promise.resolve();
        },
        events: {
            onClick: this.props.onClick
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent2/work/8b1685a0cde68c49/src/.tmp/ApplyWithButtons/View.js
// module id = 577
// module chunks = 0